// @ts-nocheck



import React from 'react';
import Tree from 'antd/lib/tree';



const { TreeNode } = Tree;








const renderNode = (node) => {
  if (node.children && node.children.length) {
    return (
      <TreeNode key={node.id} title={node.name}>
        {node.children.map((child) => renderNode(child))}
      </TreeNode>);

  }
  return <TreeNode key={node.id} title={node.name} isLeaf />;
};

const OrgUnitTree = ({ tree, onSelect, defaultSelectedKeys }) =>
<Tree
  defaultExpandAll
  onSelect={onSelect}
  defaultSelectedKeys={defaultSelectedKeys}>

    {renderNode(tree)}
  </Tree>;

export default OrgUnitTree;
